/**
 * Client service for Construction DPR and Site Diary.
 * R39 B2.a + B2.b (plan docs/plans/sector-operations.md row B2 :62).
 * Wraps callables via callable(); components never import firebase/*.
 */

import { callable } from './callable'
import type {
  OpsRecord,
  ConDprBlock,
  ConDiaryEntry,
  SaveDprDraftInput,
  SubmitDprInput,
  ReviewDprInput,
  ReturnDprInput,
  ApproveDprInput,
  GetDprInput,
  GetDprResult,
  ListDprsInput,
  AddDiaryEntryInput,
  ListDiaryEntriesInput,
} from '../types/ops'

export async function saveDprDraft(
  input: SaveDprDraftInput,
): Promise<{ recordId: string; state: 'DRAFT'; replayed?: boolean }> {
  return callable<SaveDprDraftInput, { recordId: string; state: 'DRAFT'; replayed?: boolean }>(
    'saveDprDraft',
    input,
  )
}

export async function submitDpr(
  input: SubmitDprInput,
): Promise<{ recordId: string; state: 'SUBMITTED'; replayed?: boolean }> {
  return callable<SubmitDprInput, { recordId: string; state: 'SUBMITTED'; replayed?: boolean }>(
    'submitDpr',
    input,
  )
}

export async function reviewDpr(
  input: ReviewDprInput,
): Promise<{ recordId: string; state: 'REVIEWED'; replayed?: boolean }> {
  return callable<ReviewDprInput, { recordId: string; state: 'REVIEWED'; replayed?: boolean }>(
    'reviewDpr',
    input,
  )
}

export async function returnDpr(
  input: ReturnDprInput,
): Promise<{ recordId: string; state: 'RETURNED'; replayed?: boolean }> {
  return callable<ReturnDprInput, { recordId: string; state: 'RETURNED'; replayed?: boolean }>(
    'returnDpr',
    input,
  )
}

export async function approveDpr(
  input: ApproveDprInput,
): Promise<{ recordId: string; state: 'APPROVED'; replayed?: boolean }> {
  return callable<ApproveDprInput, { recordId: string; state: 'APPROVED'; replayed?: boolean }>(
    'approveDpr',
    input,
  )
}

export async function getDpr(
  input: GetDprInput,
): Promise<GetDprResult> {
  return callable<GetDprInput, GetDprResult>(
    'getDpr',
    input,
  )
}

export async function listDprs(
  input: ListDprsInput,
): Promise<{ records: Array<OpsRecord & { dpr?: ConDprBlock }> }> {
  return callable<ListDprsInput, { records: Array<OpsRecord & { dpr?: ConDprBlock }> }>(
    'listDprs',
    input,
  )
}

export async function addDiaryEntry(
  input: AddDiaryEntryInput,
): Promise<{ entryId: string; entry: ConDiaryEntry; replayed?: boolean }> {
  return callable<AddDiaryEntryInput, { entryId: string; entry: ConDiaryEntry; replayed?: boolean }>(
    'addDiaryEntry',
    input,
  )
}

export async function listDiaryEntries(
  input: ListDiaryEntriesInput,
): Promise<{ entries: ConDiaryEntry[] }> {
  return callable<ListDiaryEntriesInput, { entries: ConDiaryEntry[] }>(
    'listDiaryEntries',
    input,
  )
}
